import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import isLoggedIn from '../utils/index';
import { pull } from 'lodash/array';
import UserInterestsStep1 from '../components/UserInterestsStep1';
import UserInterestsStep2 from '../components/UserInterestsStep2';
import { loadMyInterests, saveMyInterests, updateMyInterests, doSaveUserInfoStep } from '../actions';

const PAGES = {
  Step1: UserInterestsStep1,
  Step2: UserInterestsStep2
}


class UserInfo extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    pageStep: PAGES.Step1,
    categoryRootObjs: [],
    isFirstTime: true
  };

  formatInitialMyInterestsObj = childCategoryIds => {
    const { categories } = this.props.baseState;
    let tmpChildIds = [];
    let tmpCategoryRootObjs = [];

    for (let i = 0; i < categories.length; i++) {
      var isMatched = false;
      for (let j = 0; j < categories[i].children.length; j++) {
        if (childCategoryIds.indexOf(categories[i].children[j].id) != -1) {
          isMatched = true;
          tmpChildIds.push(categories[i].children[j].id);
        }
      } // end j loop
      if (isMatched) {
        tmpCategoryRootObjs.push({rootid: categories[i].id, childId: tmpChildIds})
        tmpChildIds = [];
      }

    }
    if (this.state.isFirstTime) {
      this.setState({isFirstTime: false})
    }
    this.setState({categoryRootObjs: tmpCategoryRootObjs});
  }

  componentWillReceiveProps(nextProps) {
    const { myInterests } = nextProps;
    if (myInterests.isLoaded) {

      if (this.state.isFirstTime) {
        this.formatInitialMyInterestsObj(myInterests.categoryIds);
      }

    }
  }

  componentWillMount() {
    if(!isLoggedIn(this.props.auth.user)) {
      this.props.push('/join?next=/user/info');
    }
    this.props.loadMyInterests();
  }

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
    let newState = this.state;

  }

  redirectUser = () => {
    this.props.push('/my/favorites');
  }

  nextPrev = direction => {
    if (direction == 'next') {
      this.setState({ pageStep: PAGES.Step2 })
    } else {
      this.setState({ pageStep: PAGES.Step1 })
    }
  }

  goToStep2 = () => {
    this.setState({ pageStep: PAGES.Step2 })
  }

  updateParentCategoryChildState = (childCategoryId, categoryRootId) => {

    // find the array el with rootid == categoryRootId
    let updateCategoryRootObj = this.state.categoryRootObjs.filter((obj) => {
      return obj.rootid == categoryRootId;
    });

    if (updateCategoryRootObj[0].childId.indexOf(childCategoryId) == -1) {
      // Push categoryChildId to this obj
      updateCategoryRootObj[0].childId.push(childCategoryId);
    } else {
      // Pull categoryChildId from this obj
      updateCategoryRootObj[0].childId = pull(updateCategoryRootObj[0].childId, childCategoryId);
    }
  }

  setParentCategoryState = categoryObj => {
    if (categoryObj) {
      this.setState({categoryRootObjs: categoryObj}, function(){
        // do something with new state
      });
    }
  }

  render() {

    let pageHeaderCopy = '';

    if (this.state.pageStep == PAGES.Step1) {
      pageHeaderCopy = <div className="profile-interestFormHeader">
        Get started by picking a few interests so we can keep you updated
      </div>;
    }

    if (this.state.pageStep == PAGES.Step2) {
      pageHeaderCopy = <div className="profile-interestFormHeader">
        Now narrow it down
      </div>;
    }

    let nextPrevButtons = '';
    let pageStepsClass = '';

    if (this.state.categoryRootObjs.length == 0) {
      nextPrevButtons = '';
    }

    if ((this.state.pageStep == PAGES.Step1) && (this.state.categoryRootObjs.length !== 0)) {
      nextPrevButtons = <a className="user-info-btn" href="#" onClick={this.nextPrev.bind(null, 'next')}>NEXT &gt;&gt;</a>
    }

    if (this.state.pageStep == PAGES.Step2) {
      nextPrevButtons = <a className="user-info-btn user-info-btn-page2" href="#" onClick={this.nextPrev.bind(null, 'prev')}>&lt;&lt; PREVIOUS</a>

      pageStepsClass = 'content-wrapper-narrow';
    }

    let Tag = this.state.pageStep;
    return (
      <div className="userInfo">

        <div className={`content-wrapper ${pageStepsClass}`}>


          { pageHeaderCopy }

          <div className="userInfo-interestsBtn-mobile">
            { nextPrevButtons }
          </div>


          <div>
            <Tag
              setParentCategoryState={this.setParentCategoryState}
              baseState={this.props.baseState}
              currentPageUrl = {this.props.routing.locationBeforeTransitions.pathname}
              browser={this.props.browser}
              saveMyInterests={this.props.saveMyInterests}
              updateMyInterests={this.props.updateMyInterests}
              loadMyInterests={this.props.loadMyInterests}
              auth={this.props.auth}
              onChange={this.goToStep2}
              categoryRootsChecked={this.state.categoryRootObjs}
              updateParentCategoryChildState={this.updateParentCategoryChildState}
              categoryRootObjs={this.state.categoryRootObjs}
              myInterests={this.props.myInterests.categoryIds}
              redirectUser={this.redirectUser}
              doSaveUserInfoStep={this.props.doSaveUserInfoStep}
            />
          </div>



        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    replace,
    loadMyInterests,
    saveMyInterests,
    updateMyInterests,
    doSaveUserInfoStep,
  }
)(UserInfo);



// WEBPACK FOOTER //
// ./src/containers/UserInfo.jsx